<template>
  <base-layout :layout-classes="layoutClasses">
    <template v-if="isMobile && mobilePageTitle" v-slot:header>
      <div class="mobile-history-header d-flex justify-content-between align-items-center">
        <div
          class="cursor-pointer"
          style="height: fit-content; width: 30px"
          @click="$router.go(-1)"
        >
          <img :src="`${$s3}/img/common/history/backArrow.svg?${$ver}`" style="height: 18px" />
        </div>
        <div class="mobile-header-title">
          {{ $t(mobilePageTitle) }}
        </div>
        <div style="height: fit-content; width: 30px">
          <!-- <img
            :src="`img/Header/map_mobile.svg?${$ver}`"
            style="height: 22px; float: right"
          /> -->
        </div>
      </div>
    </template>
  </base-layout>
</template>

<script>
import BaseLayout from '../Base';
import { mapState } from 'vuex';

export default {
  name: 'LayoutBackend',
  components: {
    BaseLayout,
  },
  data() {
    return {
      layoutClasses: {
        sideOverlay: '',
        sidebar: 'd-block',
        header: '',
        footer: '',
      },
    };
  },
  created() {
    this.$store.commit('setLayout', {
      header: true,
      sidebar: true,
      sideOverlay: true,
      footer: true,
    });
  },
  methods: {},
  computed: {
    ...mapState({
      mobilePageTitle: (state) => state.mobilePageTitle,
      isMobile: (state) => state.isMobile,
    }),
  },
};
</script>
